import { DATE_FORMAT } from '../../../shared/constants'
import { PaginateModel } from '../../../shared/models/PaginateModel'
import { UserTransactionAction } from '../constants'
import moment from 'moment'

export interface BillingFilterModel extends PaginateModel {
  startDate?: string
  endDate?: string
  action?: UserTransactionAction
}

export const createDefaultBillingFilter = (): BillingFilterModel => ({
  page: 1,
  pageCount: 0,
  take: Number(process.env.REACT_APP_DEFAULT_PAGE_SIZE) ?? 10,
  itemCount: 0,
  action: UserTransactionAction.OUT,
  startDate: moment().subtract(1, 'month').format(DATE_FORMAT), // Default to one month ago
  endDate: moment().format(DATE_FORMAT) // Default to today
})

export const validateBillingFilter = (filter: BillingFilterModel): { isValid: boolean; errors: string[] } => {
  const errors: string[] = []
  
  // Validate start date and end date
  if (filter.startDate && filter.endDate) {
    const startDate = moment(filter.startDate)
    const endDate = moment(filter.endDate)
    
    if (startDate.isAfter(endDate)) {
      errors.push('Start date must be before end date')
    }
  }
  
  // Validate date format
  if (filter.startDate && !moment(filter.startDate, DATE_FORMAT, true).isValid()) {
    errors.push('Invalid start date format')
  }
  
  if (filter.endDate && !moment(filter.endDate, DATE_FORMAT, true).isValid()) {
    errors.push('Invalid end date format')
  }
  
  // Validate type
  if (filter.action && !Object.values(UserTransactionAction).includes(filter.action)) {
    errors.push('Invalid transaction type')
  }
  
  return {
    isValid: errors.length === 0,
    errors
  }
}
